import { render, staticRenderFns } from "./Equipos.vue?vue&type=template&id=540b7740&"
import script from "./Equipos.vue?vue&type=script&lang=js&"
export * from "./Equipos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports